"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* exported Tunstall_BW129 */

var Tunstall_BW129_reader = function (_BleReader) {
  _inherits(Tunstall_BW129_reader, _BleReader);

  function Tunstall_BW129_reader() {
    _classCallCheck(this, Tunstall_BW129_reader);

    return _possibleConstructorReturn(this, (Tunstall_BW129_reader.__proto__ || Object.getPrototypeOf(Tunstall_BW129_reader)).apply(this, arguments));
  }

  _createClass(Tunstall_BW129_reader, [{
    key: "onConnect",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!params.units) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.setUnits(params.units);

              case 3:
                return _context.abrupt("return", this.getBatteryStatus());

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onConnect(_x) {
        return _ref.apply(this, arguments);
      }

      return onConnect;
    }()
  }, {
    key: "setUnits",
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(unitName) {
        var byteArray, i;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                byteArray = new Uint8Array(20);

                for (i = 0; i < 20; i++) {
                  byteArray[i] = 0;
                }
                byteArray[0] = 1;
                byteArray[1] = unitName == "kg" ? 0 : 1;

                return _context2.abrupt("return", this.writeWithoutResponse("18c3ff01-9d2d-4113-b83b-66dc5aebc888", "18c3ff08-9d2d-4113-b83b-66dc5aebc888", byteArray.buffer));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setUnits(_x2) {
        return _ref2.apply(this, arguments);
      }

      return setUnits;
    }()
  }]);

  return Tunstall_BW129_reader;
}(BleReader);

var Tunstall_BW129 = new JS.Class(BLE_Device, {
  initialize: function initialize(device_uuid) {
    var name = "Tunstall BW129";
    var model_name = "BW129";
    //var device_uuid = device_uuid; //"C3:45:DA:74:19:DB";
    var service_uuid = "1810";
    var measurement_uuids = ["2a35", "2a36"];

    this.advertised_name = "ScaleDevice";
    return this.callSuper(name, model_name, device_uuid, service_uuid, measurement_uuids);
  },

  _decode_result: function _decode_result(result, reader) {
    var result_byte_array = new Uint8Array(result);

    var weight = kanayo.util.combine_bytes_for_integer([result_byte_array[2], result_byte_array[1]], false);
    weight = weight.toString().replace(/(.)$/, ".$1"); // insert decimal point
    var zero_weight = kanayo.util.combine_bytes_for_integer([result_byte_array[4], result_byte_array[3]], true);
    zero_weight = zero_weight.toString().replace(/(.)$/, ".$1"); // insert decimal point
    var status = this._decode_status_byte(result_byte_array[18]);
    var date = new Date();
    console.log(status);
    console.log("zwt:" + zero_weight);
    console.log("wt:" + weight);

    return {
      valid: status.locked,
      date: date,
      readings: [{ main: true,
        measurements: [{ name: "wt", value: "" + weight, unit: status.units, designations: [] }, { name: "zwt", value: "" + zero_weight, unit: status.units, designations: [] }]
      }]
    };
  },

  _decode_status_byte: function _decode_status_byte(status_byte) {
    var bit_string = status_byte.toString(2);
    //Make sure byte string is 8 bits by padding MSBs with zeros
    while (bit_string.length < 8) {
      bit_string = "0" + bit_string;
    }

    return {
      units: bit_string[7] == "1" ? 'lbs' : 'kg',
      locked: bit_string[0] == "1" ? true : false
    };
  },

  makeReader: function makeReader() {
    return new Tunstall_BW129_reader(this);
  },

  settableUnits: function settableUnits() {
    return [{ text: 'kg', value: 'kg' }, { text: 'lbs', value: 'lbs' }];
  }
});